export default {"src":"/_next/static/media/icon-creator.4c1d701e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};